<template>
    <div class="body" v-if="is_loading">
        <!-- 네비게이션 -->
        <Head :time="current_time" :total_question="total_question" :current_question="current_question" @next="next" :total_part="total_part" :current_part="part"></Head>


        <div class="wrap body-con">
            <h2>다음 문장을 영어로 작성하세요.</h2>
            <h3>{{modules.part[this.part][current_question].question}}</h3>
            <div>
                <p class="txt-gray-light">Word Count {{word_count}}</p>
                <textarea name="" id="" rows="5" class="mt-10" @keyup="inputWord" v-model="answer"></textarea>
            </div>
        </div>

        <div class="wrap" v-if="is_nextBtn">
            <div class="btn-fixed" v-if="is_next"><button class="btn-full"  @click="next()">NEXT</button></div>
            <div class="btn-fixed"  v-if="!is_next"><button class="btn-full on" >NEXT</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
import Head from '@/components/inc_head.vue';
export default {
    name: 'Pre_part03',
    components: {
        Footer,
        Head
    },
    data: () => ({
        current_time : {time:0},
        total_question:0,
        current_question:0,
        is_loading:false,
        modules:{},
        part:3,
        answer:"",
        total_part:{part:0},
        type:"",
        word_count:0,
        is_next:false,
        is_nextBtn:true
    }),
    mounted() {
        // console.log(btoa(encodeURIComponent('{"total_part":"6","total_question":3,"module_name":"module3","type":"4","modules":{"part":{"3":[{"second":60,"number":"1","question":"저와 약속하셨나요?","statement":{"1":"Did you make an appointment with me?"},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":60,"number":"2","question":"모든 일이 순조롭게 진행이 되고있어서 일정에 차질이 없을 것 같습니다.","statement":{"1":"Everything is going smoothly, so I think things will be done on time./Everything is going fine, so things will be on schedule."},"img_url":"","mp3_url":"","directive":"","help_word":""},{"second":60,"number":"3","question":"어제 언급한 보고서가 얼마나 진척이 되었나요?","statement":{"1":"How far along are you with the report you mentioned yesterday?"},"img_url":"","mp3_url":"","directive":"","help_word":""}]}},"submit_answer":0}')));

    //    this.type = this.$route.params.type;
       this.getQuestion();
    },
    methods: {
        isMobile(){
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        setFocus(){
            // alert("a");
            // console.log("a");
            // console.log(this.isMobile());
            if(this.isMobile()){
                this.is_nextBtn = false;
            }
        },
        setBlur(){
            if(this.isMobile()){
                this.is_nextBtn = true;
            }
        },
        getQuestion(){
            var moduel_str = decodeURIComponent(atob(this.$route.params.module));
            var module_json = JSON.parse(moduel_str);
            console.log(module_json);

            this.modules = module_json.modules;
            this.total_part = {part:parseInt(module_json.total_part)};
            this.total_question = module_json.total_question;
            this.current_question = parseInt(module_json.submit_answer);
            this.current_time.time = module_json.modules.part[this.part][this.current_question].second * 1000;
            this.is_loading = true;
            // var params = {
            //     type:this.type,
            //     part:this.part
            // }
            // this.axios.get(this.axios.root + "/rest/module_info/getQuestions",{params:params}).then((res)=>{
            //     console.log(res);
            //     if(res.data.err == 0){
            //         this.total_part = {part:parseInt(res.data.data.total_part)};
            //         this.total_question = res.data.data.total_question;
            //         this.modules = res.data.data.modules;
            //         this.current_question = parseInt(res.data.data.submit_answer);
            //         this.current_time.time = this.modules.part[this.part][this.current_question].second * 1000;
            //         this.is_loading = true;
            //     }else if(res.data.err == 5000){
            //         alert(res.data.err_msg);
            //         sessionStorage.clear();
            //         location.href="/intro";
            //     }else if(res.data.err == 6001){
            //         alert(res.data.err_msg);
            //         this.$router.push('/part04/'+this.type);
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // })
        },
        next(){
            this.answer = this.answer.trim();
            this.answer = "";
            this.memetos = [];
            this.select_item = [];
            this.word_count = 0;
            this.current_question++;
            this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            // var params = {
            //     part :this.part,
            //     number : (this.current_question+1),
            //     type:this.type,
            //     student_idx:sessionStorage.getItem("student_idx"),
            //     answer:this.answer
            // }
            // console.log(params);
            // this.axios.post(this.axios.root + "/rest/access/answerSubmit",params).then((res) => {
            //     if(res.data.err == 0){
            //         this.answer = "";
            //         this.memetos = [];
            //         this.select_item = [];
            //         this.word_count = 0;
            //         if((this.current_question + 1) == this.modules.part[this.part].length){
            //             this.$router.push('/part04/'+this.type);
            //         }else{
            //             this.current_question++;
            //             this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
            //         }
            //     }else{
            //         alert(res.data.err_msg);
            //         return false;
            //     }
            // });
        },
        inputWord(e){
            this.answer = e.target.value;
            // console.log(this.answer);
            var answerSplit = this.answer.split(" ");
            // console.log(answerSplit.length - 1);
            // this.word_count = this.answer.replace(/ /gi, "").length;
            this.word_count = answerSplit.length - 1;
            this.is_next = true;
        }
    }
}
</script>